var link = jQuery('.gallery__list li a');
var image = jQuery('.gallery__image');
var zoom = jQuery('.gallery__zoom')

jQuery(link).click(function(event){
	event.preventDefault();
	var src = jQuery(this).data('src');
	jQuery(image).attr('src', src);
	jQuery(zoom).attr('src', src);
});